<template>
<div class="chapter">
<div class="inner_page">
<p class="image1a"><a id="ch00_fm04"></a><a id="page_iv"><img alt="image" src="images/f00iv-01.jpg"/></a></p><a id="page_iv">
</a><p class="copyright"><a id="page_iv">SIMON &amp; SCHUSTER<br/>Rockefeller Center<br/>1230 Avenue of the Americas<br/>New York, NY 10020<br/></a><a class="nounder" href="http://www.SimonandSchuster.com" target="_blank">www.SimonandSchuster.com</a></p>
<p class="copyrightv">This book is a work of fiction. Names, characters,<br/>places, and incidents either are products of the<br/>author’s imagination or are used fictitiously. Any<br/>resemblance to actual events or locales or persons,<br/>living or dead, is entirely coincidental.</p>
<p class="copyrightv">Copyright © 2004 by Laurie Fox<br/>All rights reserved,<br/>including the right of reproduction<br/>in whole or in part in any form.</p>
<p class="copyrightv">S<span class="smallcaps">IMON</span> &amp; S<span class="smallcaps">CHUSTER</span> and colophon are registered trademarks<br/>of Simon &amp; Schuster, Inc.</p>
<p class="copyrightv"><em>Book design by Ellen R. Sasahara</em></p>
<p class="copyrightv">Manufactured in the United States of America</p>
<p class="copyrightv">1   3   5   7   9   10   8   6   4   2</p>
<p class="copyrightv">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyrightv">Fox, Laurie Anne.<br/>The lost girls / Laurie Fox.<br/>p. cm.<br/>1. Middle aged women—Fiction. 2. San Francisco (Calif.)—Fiction.<br/>3. Peter Pan (Fictitious character)—Fiction. I. Title.<br/>PS3556.O936L67 2004</p>
<p class="copyrightv">813'.54—dc22                                        2003 059168</p>
<p class="copyrightv">0-7432-1790-X</p>
<p class="copyrightv">Permissions:<br/>Excerpt from “The Breast,” from <em>Love Poems,</em> by Anne Sexton.<br/>Copyright © 1967, 1968, 1969 by Anne Sexton. Reprinted by permission<br/>of Houghton Mifflin Company. All rights reserved.<br/>Excerpt from <em>Love Story,</em> by Erich Segal. Copyright © 1970 by Erich Segal.<br/>Reprinted by permission of HarperCollins Publishers Inc.<br/>Excerpt from “A Case of You,” by Joni Mitchell. Copyright © 1972 by<br/>Joni Mitchell Publishing Corp. All rights administered by<br/>Sony/ATV Publishing, 8 Music Square West, Nashville, TN 37203.<br/>All rights reserved. Used by permission.</p>
<p class="copyrightv">ISBN-13: 978-0-7432-1790-3<br/>eISBN-13: 978-0-7432-5357-4</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04.vue?493e6219